import React, { useState, useEffect } from "react";
import { Badge, Card } from "react-bootstrap";
import { getCurrentUser } from 'aws-amplify/auth';

import './css/HomePage.css'

const HomePage = () => {
  const [user, setUser] = useState("");
  const [fadeIn, setFadeIn] = useState(false); // stato animazione

  const checkUser = async () => {
    try {
      const user = await getCurrentUser();
      setUser(user.username);
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  useEffect(() => {
    checkUser();
    const timeout = setTimeout(() => setFadeIn(true), 200); // delay fade-in
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="my-home-page">

      <Card className={`welcome-card ${fadeIn ? 'fade-in' : ''}`}>
        <h1 className="title">
          Dashboard Analisi Laser 2D — <span className="brand">Prima Power</span>
        </h1>

        <Badge bg="warning" text="dark" className="user-badge">
          Benvenuto<br /><strong>{user.toUpperCase()}</strong>
        </Badge>
      </Card>

    </div>
  );
};

export default HomePage;
